<script>
export default {
  props: {
    entries: { type: Array, default: () => [] },
  },
  computed: {
    convertedString() {
      return `data:text/csv;charset=utf-8,${this.rows.join('\n')}`
    },
    headerKeys() {
      if (!this.entries.length > 0) {
        return []
      }
      return Object.keys(this.entries[0])
    },
    rows() {
      return [
        // rows are generated based on the headers
        // so it doesnt end up with incorrectly numbered columns
        this.headerKeys.map((k) => k.replace(/^\w/, (c) => c.toUpperCase())).join(','),
        ...this.processedEntries,
      ]
    },
    processedEntries() {
      return [
        ...this.entries.map((entry) =>
          this.headerKeys.map((k) => (entry[k] ? `"${entry[k]}"` : '')).join(','),
        ),
      ]
    },
  },
  render() {
    return this.$slots.default({
      convertedString: this.convertedString,
    })
  },
}
</script>
